import React from "react";
import CleanNavBar from "../Layout/CleanNavBar";
import CleanFooter from "../Layout/CleanFooter";

const AboutUs = () => {
  return (
    <div className="page-wrapper">
      <CleanNavBar />
      <div className="page-content">
        <div className="page-header">
          <h1>About GlobeCab</h1>
        </div>
        <div className="clean-container">
          <div className="content-section">
            <h2>The World's Most Trusted Taxi Service</h2>
            <p>
              Founded in 2010, GlobeCab has grown to become the world's leading taxi service provider, 
              operating in over 150 cities across 40 countries. We pride ourselves on providing safe, 
              reliable, and comfortable transportation to millions of passengers every day.
            </p>
            
            <h3>Our Mission</h3>
            <p>
              To provide safe, reliable, and affordable transportation that connects people and places, 
              while setting the global standard for customer service in the taxi industry.
            </p>
            
            <h3>Our Global Network</h3>
            <p>
              With operations centers in London, New York, Tokyo, and Dubai, we coordinate a vast network 
              of over 50,000 professional drivers worldwide. Our multilingual support team is available 
              24/7 in 30+ languages to assist passengers wherever they travel.
            </p>
            
            <h3>Our Track Record</h3>
            <ul>
              <li>3,000+ rides completed daily</li>
              <li>50,000+ professional drivers</li>
              <li>4.8/5 average customer rating</li>
              <li>5-minute average pickup time</li>
              <li>96% on-time arrival rate</li>
            </ul>
            
            <h3>Services We Offer</h3>
            <p>
              Airport Transfers, Corporate Travel Solutions, City Tours, Hourly Rentals, 
              Long-Distance Travel, and Special Event Transportation.
            </p>
          </div>
        </div>
      </div>
      <CleanFooter />
    </div>
  );
};

export default AboutUs;